import { BulkActionType, } from '@debbie/common/dist/insights/bulk-actions.js';
import { UpdateType } from '@debbie/common/dist/updates/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { getNextTasks } from '@debbie/common/dist/workflows/index.js';
import * as insightsAPI from '@debbie/cortex/dist/api/insights.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useUpdateTypesMap } from '@debbie/cortex/dist/update-types/index.js';
import { useWorkflows } from '@debbie/cortex/dist/workflows/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../theme.js';
import { errorNotification } from '../../utils/errors.js';
import ActiveUpdate from '../CasePauseStatus/ActiveUpdate.js';
import { Menu, Play } from '../Icons/index.js';
import { Button, Checkbox, Modal, PlaceholderLoader } from '../index.js';
import UpdateTypeLabel from '../UpdateTypeLabel.js';
const TodoBulkActions = (props) => {
    const { updates, checkedUpdates, setCheckedUpdates, caseFilter } = props;
    const lang = useSelector((state) => state.lang);
    const [bulkActionModalOpen, setBulkActionModalOpen] = useState(false);
    const updatesToBulk = Object.values(checkedUpdates).length
        ? updates.filter((update) => checkedUpdates[update.referenceId])
        : [];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                marginBottom: '.5em',
            } },
            updates[0]?.updateTypeId !== UpdateType.SentToConnectPartner && (React.createElement("span", { style: {
                    color: updatesToBulk.length > 1 ? THEME.COLOR_ACCENT : '#6e6e6e',
                    fontWeight: '900',
                    fontSize: '.7em',
                    cursor: updatesToBulk.length > 1 ? 'pointer' : 'not-allowed',
                    float: 'right',
                }, title: updatesToBulk.length <= 1
                    ? lang.updates.chooseMoreThanTwoBulkActions
                    : undefined, onClick: () => {
                    if (updatesToBulk.length > 1) {
                        setBulkActionModalOpen(!bulkActionModalOpen);
                    }
                } },
                lang.updates.bulkActions,
                ' ',
                React.createElement(Menu, { style: {
                        margin: '.2em 0 -.2em',
                    } }))),
            React.createElement(Checkbox, { checkMark: true, checkboxStyle: {
                    fontSize: '16px',
                }, style: {
                    color: THEME.COLOR_ACCENT,
                    fontWeight: '900',
                    fontSize: '.7em',
                    cursor: 'pointer',
                }, checked: !updates.find((update) => !checkedUpdates[update.referenceId]), onChange: (e) => {
                    if (e.target.checked) {
                        setCheckedUpdates(updates.reduce((acc, update) => {
                            acc[update.referenceId] = true;
                            return acc;
                        }, {}));
                    }
                    else {
                        setCheckedUpdates({});
                    }
                }, placeholder: lang.updates.selectAll })),
        bulkActionModalOpen && (React.createElement(Modal, { header: lang.updates.bulkActions, onToggle: () => setBulkActionModalOpen(!bulkActionModalOpen), maxWidth: "1200px" },
            React.createElement(BulkActionsTasks, { updatesToBulk: updatesToBulk, caseFilter: caseFilter })))));
};
export default TodoBulkActions;
const BulkActionsTasks = (props) => {
    const { updatesToBulk, caseFilter } = props;
    const [updatesDone, setUpdatesDone] = useState(false);
    const [wfDone, setWfDone] = useState({});
    const workflowTasks = Object.values(updatesToBulk.reduce((acc, update) => {
        if (update.workflowId && update.taskId) {
            if (!acc[update.workflowId]) {
                acc[update.workflowId] = {
                    updateTypeId: update.updateTypeId,
                    taskId: update.taskId,
                    workflowId: update.workflowId,
                    updates: [],
                };
            }
            acc[update.workflowId].updates =
                acc[update.workflowId].updates.concat(update);
        }
        return acc;
    }, {}));
    const continueTasks = updatesToBulk.reduce((acc, update) => {
        if (!(update.workflowId && update.taskId)) {
            acc = acc.concat(update);
        }
        return acc;
    }, []);
    return (React.createElement("div", null,
        workflowTasks.length
            ? workflowTasks.map((wT) => !wfDone[wT.workflowId] ? (React.createElement(WorkflowTask, { key: wT.workflowId, workflowId: wT.workflowId, queuedTodos: wT.updates, updateTypeId: wT.updateTypeId, taskId: wT.taskId, caseFilter: caseFilter, onDone: () => {
                    setWfDone({
                        ...wfDone,
                        [wT.workflowId]: true,
                    });
                } })) : null)
            : null,
        !updatesDone && continueTasks.length ? (React.createElement(Update, { updateTypeId: continueTasks[0].updateTypeId, queuedTodos: continueTasks, caseFilter: caseFilter, onDone: () => {
                setUpdatesDone(true);
            } })) : null));
};
const WorkflowTask = (props) => {
    const { workflowId, queuedTodos, updateTypeId, taskId, caseFilter } = props;
    const workflowsLoadable = useWorkflows();
    const workflows = h.hasData(workflowsLoadable) ? workflowsLoadable.data : null;
    const workflow = workflows?.find((w) => w.workflowId === workflowId);
    const updateTypesMapLoadable = useUpdateTypesMap();
    const updateTypesMap = h.hasData(updateTypesMapLoadable)
        ? updateTypesMapLoadable.data
        : {};
    const updateType = updateTypesMap[updateTypeId];
    if (!updateType) {
        return null;
    }
    const next = workflow ? getNextTasks(workflow, taskId) : null;
    if (!workflow) {
        return React.createElement(PlaceholderLoader, null);
    }
    return (React.createElement(ActiveUpdate, { actions: React.createElement(React.Fragment, null, next &&
            next.map(({ task }) => (React.createElement(NextTaskButton, { targetTask: task, caseFilter: caseFilter, workflowId: workflowId, updateTypeId: updateTypeId, queuedTodos: queuedTodos, onDone: props.onDone })))), updateTypeId: updateTypeId, quantity: queuedTodos.length, description: workflow.title }));
};
const NextTaskButton = (props) => {
    const { caseFilter, targetTask, workflowId, updateTypeId, queuedTodos } = props;
    const lang = useSelector((state) => state.lang);
    const updateTypesMapLoadable = useUpdateTypesMap();
    const updateTypesMap = h.hasData(updateTypesMapLoadable)
        ? updateTypesMapLoadable.data
        : {};
    const updateType = updateTypesMap[targetTask.updateTypeId];
    const bulkActionMutation = useMutation(async () => {
        const bulkActionToTask = {
            type: BulkActionType.MoveCaseToWorkflowTask,
            details: {
                workflowId,
                targetTaskId: targetTask.id,
            },
        };
        await insightsAPI.caseFilterBulk({
            ...caseFilter,
            caseIds: queuedTodos.map((todo) => todo.referenceId),
        }, bulkActionToTask, {
            noConfirmationEmail: true,
        });
        // TODO: Continue source update on backend
        const bulkActionContinue = {
            type: BulkActionType.ContinueCases,
            details: {
                updateTypeId,
            },
        };
        await insightsAPI.caseFilterBulk({
            ...caseFilter,
            caseIds: queuedTodos.map((todo) => todo.referenceId),
        }, bulkActionContinue, {
            noConfirmationEmail: true,
        });
    }, {
        onSuccess: () => {
            props.onDone();
        },
        onError: (err) => {
            errorNotification(lang, err, 'any', lang.errorEntities.bulkActions);
        },
    });
    if (!updateType) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { loading: bulkActionMutation.isLoading, size: "small", onClick: () => bulkActionMutation.mutate() },
            React.createElement(UpdateTypeLabel, { label: updateType.label, updateTypeId: updateType.updateTypeId })),
        ' '));
};
const Update = (props) => {
    const { updateTypeId, queuedTodos, caseFilter } = props;
    const lang = useSelector((state) => state.lang);
    const updateTypesMapLoadable = useUpdateTypesMap();
    const updateTypesMap = h.hasData(updateTypesMapLoadable)
        ? updateTypesMapLoadable.data
        : {};
    const updateType = updateTypesMap[updateTypeId];
    const continueButton = updateType ? !updateType.pausing : false;
    const continueMutation = useMutation(async () => {
        const bulkActionContinue = {
            type: BulkActionType.ContinueCases,
            details: {
                updateTypeId,
            },
        };
        await insightsAPI.caseFilterBulk({
            ...caseFilter,
            caseIds: queuedTodos.map((todo) => todo.referenceId),
        }, bulkActionContinue, {
            noConfirmationEmail: true,
        });
    }, {
        onSuccess: () => {
            props.onDone();
        },
        onError: (err) => {
            errorNotification(lang, err, 'any', lang.errorEntities.bulkActions);
        },
    });
    if (!updateType) {
        return null;
    }
    return (React.createElement(ActiveUpdate, { actions: React.createElement(Button, { blockOnMobile: true, loading: continueMutation.isLoading, size: "small", theme: continueButton ? 'secondary' : 'warning', onClick: () => continueMutation.mutate() },
            React.createElement(Play, { style: { margin: '0.1em 0 -.2em' } }),
            ' ',
            continueButton
                ? lang.updates.continueCaseRemove
                : lang.updates.continueCase), updateTypeId: updateTypeId, quantity: queuedTodos.length }));
};
//# sourceMappingURL=TodoBulkActions.js.map